export default {
    driver_performance_cases_filters_timeFrame: "Período de Tiempo",
    driver_performance_cases_filters_coach: "Supervisor",
    driver_performance_cases_filters_status: "Estado",
    driver_performance_cases_filters_drivers: "Conductores",
    driver_performance_cases_filters_tags: "Etiquetas",
    driver_performance_cases_filters_pending: "Pendiente",
    driver_performance_cases_filters_evaluate: "Evaluar",
    driver_performance_cases_filters_completed: "Completado",
    driver_performance_cases_filters_expired: "Expirado",
};
